export const HistoryCommandName = 'HistoryCommandComponent';
